import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div``;

const Title = styled(Headline)`
  padding: 1.5rem;

  border-bottom: 0.1rem solid ${pickColor('borderSemiLight')};
`;

const ImageWrapper = styled.div`
  margin: 0 10rem;
`;

export { Container, Title, ImageWrapper };
